import {
  ApplicationRef,
  ENVIRONMENT_INITIALIZER,
  EnvironmentInjector,
  Provider,
  createComponent,
  inject,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';

import { DEFAULT_TOAST_CONFIG, TOAST_CONFIG, ToastConfig } from '@core/toast'
import { ToastContainerComponent } from '@core/ui/components/toast/index';


export function provideToastComponent(cfg?: Partial<ToastConfig>): Provider[] {
  return [
    {
      provide: TOAST_CONFIG,
      useFactory: () => ({ ...DEFAULT_TOAST_CONFIG, ...cfg })
    },
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useFactory: () => () => {
        const platformId = inject(PLATFORM_ID);
        if (!isPlatformBrowser(platformId)) return;

        const appRef = inject(ApplicationRef);
        const env = inject(EnvironmentInjector);
        const doc = inject(DOCUMENT);

        // Avoid duplicate mount
        if (doc.querySelector('app-toast-container')) return;

        const host = doc.createElement('app-toast-container');
        doc.body.appendChild(host);

        const cmpRef = createComponent(ToastContainerComponent, {
          environmentInjector: env,
          hostElement: host
        });
        appRef.attachView(cmpRef.hostView);
      }
    }
  ];
}
